import styled from 'styled-components';

export const LegalContainer = styled.div`
  margin: 0 auto;
  background: #fff;
  color: #333;
  line-height: 1.3;
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', Roboto, 'Helvetica Neue', Arial,
    sans-serif;
  padding: 40px 25%;
  width: 100%;
  overflow-y: scroll;
  height: 100%;
`;

export const Heading = styled.h1`
  font-size: 1.8rem;
  font-weight: 700;
  color: #8bc400;
  text-align: center;
  margin-bottom: 20px;
  letter-spacing: 0.5px;

  @media (max-width: 768px) {
    font-size: 2rem;
  }
`;

export const SubHeading = styled.p`
  font-size: 1.1rem;
  color: #666;
  text-align: center;
  margin-bottom: 40px;
  font-weight: 500;
`;

export const Content = styled.div`
  font-size: 1rem;

  p {
    margin-bottom: 1.2em;
    text-align: left;
  }

  h2 {
    font-size: 1rem;
    font-weight: 600;
  }

  ul {
    margin: 1em 0;
    padding-left: 2em;

    li {
      margin-bottom: 0.8em;
      line-height: 1.7;
    }
  }

  ol {
    margin: 1em 0;
    padding-left: 2em;

    li {
      margin-bottom: 0.8em;
      line-height: 1.7;
    }
  }

  a {
    color: #1890ff;
    text-decoration: none;
    border-bottom: 1px solid transparent;
    transition: border-bottom-color 0.2s ease;

    &:hover {
      border-bottom-color: currentcolor;
    }
  }

  strong,
  b {
    font-weight: 600;
    color: #262626;
  }

  /* Ensure proper spacing for nested lists */
  ul ul,
  ol ol,
  ul ol,
  ol ul {
    margin-top: 0.5em;
    margin-bottom: 0.5em;
  }

  /* Style for definition-like paragraphs */
  p:has(+ p > strong:first-child) {
    margin-bottom: 0.8em;
  }

  /* Responsive adjustments */
  @media (max-width: 768px) {
    ul,
    ol {
      padding-left: 1.5em;
    }

    h2 {
      font-size: 1.3rem;
    }
  }
`;
